import React, { PropTypes, Component } from 'react';
import { Styles } from 'material-ui';
const { Spacing } = Styles;
import { Colors, Units } from 'Css';

const css = oxygenCss({
  count: {
    position: 'absolute',
    transform: 'translateY(-50%)',
    right: Units.base,
    top: '50%',
    padding: 5,
    width: 32,
    borderRadius: '5px',
    boxShadow: 'rgba(0, 0, 0, 0.156863) 0px 3px 10px',
    backgroundColor: Colors.material.red[500].hex,
    color: Colors.text.Light.default,
    lineHeight: '16px',
    textAlign: 'center',
    fontSize: '.8em'
  }
});

export default class MenuItem extends Component {
  static propTypes = {
    style: PropTypes.object,
    leftIcon: PropTypes.node,
    primaryText: PropTypes.node,
    children: PropTypes.node
  };

  state = {
    mouseOver: false
  };

  getStyle() {
    const { style } = this.props;
    const { mouseOver } = this.state;
    return Object.assign(
      {},
      {
        position: 'relative',
        cursor: 'pointer',
        backgroundColor: mouseOver ? 'rgba(255, 255, 255, 0.2)' : 'transparent',
        paddingLeft: Spacing.desktopGutterMini,
        paddingRight: Spacing.desktopGutterMini,
        height: 48,
        lineHeight: '48px',
        fontSize: '16px'
      },
      style
    );
  }

  handleMouseEnter() {
    this.setState({ mouseOver: true });
  }

  handleMouseLeave() {
    this.setState({ mouseOver: false });
  }

  render() {
    const {
      leftIcon,
      primaryText,
      children,
      style,
      count,
      ...other
    } = this.props;
    const hasCount = !!count;
    return (
      <div
        {...other}
        style={this.getStyle()}
        onMouseEnter={this.handleMouseEnter.bind(this)}
        onMouseLeave={this.handleMouseLeave.bind(this)}
      >
        {leftIcon}
        {primaryText}
        {children}
        {hasCount && <div className={css.count}>{count}</div>}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Material/MenuItem.js